<div class="fix-action-dialog">
	<h2>{{data.name}}<span translate>の更新</span></h2>

	<mat-dialog-content>
		<form #form="ngForm" fxLayout="column" fxLayoutAlign="space-between" novalidate>
			<mat-form-field class="input-text">
				<mat-label><span translate>クラブ種類</span></mat-label>
				<mat-select [(value)]="data.platform.description.club">
					<mat-option *ngFor="let club of clubs" [value]="club.value">
						{{club.name}}
					</mat-option>
				</mat-select>
			</mat-form-field>
			<mat-form-field class="input-text">
				<textarea
					#autosize="cdkTextareaAutosize"
					#description="ngModel"
					[(ngModel)]="data.platform.description.message"
					cdkAutosizeMaxRows="5"
					cdkAutosizeMinRows="1"
					cdkTextareaAutosize
					matInput
					maxlength="1000"
					name="description"
					placeholder="コメント"
					type="text"></textarea>
				<mat-hint>1000文字まで</mat-hint>
				<mat-error *ngIf="description.errors?.['maxlength']"><span translate>長すぎます</span></mat-error>
			</mat-form-field>

			<mat-form-field class="input-text">
				<mat-label><span translate>公開設定</span></mat-label>
				<mat-select [(value)]="data.platform.scope">
					<mat-option *ngFor="let scope of scopes" [value]="scope.value">
						{{scope.name}}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</form>
	</mat-dialog-content>
	<div class="spacer"></div>
	<mat-dialog-actions fxLayout="row" fxLayoutAlign="space-around">
		<button (click)="onAccept()" color="primary" mat-raised-button id="mat-update-button"><span translate>更新</span></button>
		<button (click)="cancel()" color="warn" mat-dialog-close="" mat-stroked-button id="mat-close-button"><span translate>閉じる</span></button>
	</mat-dialog-actions>

</div>
